<template>
<!-- Main navbar -->
<nav class="navbar main-nav is-primary" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
        <div class="navbar-item" style="color: aliceblue; display:inline; padding: 6px;">
            <h3 class="subtitle is-3" style="color: white; margin-bottom: 0px; display:inline;">Route Configuration</h3>
            <small style="color: white; margin-left: 5px;"> {{version}}</small>
        </div>
        <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="mainMenu">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
        </a>
    </div>

    <div class="navbar-menu" id="mainMenu" v-if="isAuthenticated">
        <!-- Right section of the Navbar -->
        <div class="navbar-end">
            <div v-if="!isInIframe" class="navbar-item">
              <img class="acuity-logo" src="data:image/png;base64,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"/>
            </div>
            <div class="navbar-item has-dropdown is-hoverable">
                <div class=" navbar-link is-arrowless">
                    <a class="header-btn button is-light-blue is-rounded" slot="trigger">
                        <b-icon icon="account" />
                    </a>
                </div>
                <div class="navbar-dropdown is-boxed is-right user-informations">
                    <div class="hoverModal">
                        <div class="col-xs-4 col100">
                            <div class="infoLine autoHeight"><div class="autoMargin">Username</div></div>
                            <div class="infoLine autoHeight"><div class="autoMargin">Organization</div></div>
                            <div class="infoLine autoHeight"><div class="autoMargin">Rights</div></div>
                        </div>
                        <div class="col-xs-8 col100">
                            <div class="infoLine autoHeight"><div class="autoMargin">{{username}}</div></div>
                            <div class="infoLine autoHeight"><div class="autoMargin">{{orgaId}}</div></div>
                            <div class="infoLine autoHeight">
                                <div class="list-roles">
                                    <!-- {{rights}} -->
                                    <ul v-if="rights != null">
                                        <li v-for="right in rights" :key="right.index">{{right}}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!isInIframe"  class="navbar-item">
                <div class="buttons">
                    <a class="header-btn button is-light-blue is-rounded" slot="trigger" @click="logout">
                        <b-icon icon="logout" />
                        <!-- <strong>{{ $t('header.logout') }}</strong> -->
                    </a>
                </div>
            </div>
        </div>
    </div>
</nav>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'navigation',
  data () {
    return {
      version: process.env.VUE_APP_VERSION
    }
  },
  methods: {
    /** Logout */
    logout: function () {
      this.$store.dispatch('authentication/logout').then(() => this.$router.push('/login'))
    }
  },
  mounted () {
    /** Enable the burger navigation when on small device */
    document.addEventListener('DOMContentLoaded', () => {
      // Get all "navbar-burger" elements
      const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0)

      // Check if there are any navbar burgers
      if ($navbarBurgers.length > 0) {
        // Add a click event on each of them
        $navbarBurgers.forEach(el => {
          el.addEventListener('click', () => {
            // Get the target from the "data-target" attribute
            const target = el.dataset.target
            const $target = document.getElementById(target)

            // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
            el.classList.toggle('is-active')
            $target.classList.toggle('is-active')
          })
        })
      }
    })
  },
  computed: {
    ...mapGetters('authentication', ['isAuthenticated', 'username', 'orgaId', 'rights']),
    ...mapState({
      authLoading: state => state.auth.status === 'loading',
      name: state => `${state.user.username} ${state.user.organization}`
    }),
    isInIframe: () => window.top !== window.self
  }
}
</script>

<style lang="scss" scoped>
    .logout {
        &:hover {
        cursor: pointer;
        }
    }
    .main-nav {
        background-color: #448993;
        min-height: 50px;
        height: 50px;
    }
    .list-roles {
        margin: 10px 0px 5px 15px;
        text-align: left;
    }
    .header-btn{
        min-height: 44px;
    }
    .acuity-logo {
        max-height: 3rem;
        margin-right: 1.5rem;
    }
    .user-informations{
        background-color: #448993;
    }
    .item-content-left, .item-content-right{
        background-color: #63c5d4;
    }
    .hoverModal{
        width: 600px;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 0.95em;
        text-align: left;
        word-break: break-all;
        text-overflow: ellipsis;
        border-radius: 10px;
        word-wrap: break-word;
        background: #448893;
        display: grid;
        grid-template-columns: 30% auto;
        grid-gap: 0.5rem;
    }
    .autoHeight {
        height: auto;
        min-height: 33px;
    }

    .infoLine {
        width: 100%;
        font-weight: bold;
        display: -ms-flexbox;
        display: flex;
        color: white;
        margin-top: 5px;
        margin-bottom: 5px;
        border-radius: 5px;
        text-align: center;
        background-color: #70aab3 !important;
    }
    .autoMargin{
        margin: auto;
    }
</style>
